{
  "version": 1,
  "asset_id": "b82f96c3-3143-4b1f-8460-fe74ec9cc6a7",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/b82f96c3-3143-4b1f-8460-fe74ec9cc6a7/emons.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/b82f96c3-3143-4b1f-8460-fe74ec9cc6a7/emons.png",
  "original_filename": "emons.png",
  "size": 9990,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:30Z"
}
